export const GROUPS = {
  RX: {
    longName:
      'RX - Magnetic Reconnection in the Age of the Heliophysics System Observatory',
    hosts:
      'Yi Qi, John Dorelli, Katherine Goodrich, Chen Shi, M. Hasan Barbhuiya, Krishna Khanal',
  },
  RBSoS: {
    longName: 'RBSoS - Radiation Belts as a System of Systems',
    hosts: 'Harriet George, Man Hua, Adam Michael, Luisa Capannolo',
  },
  CP: {
    longName:
      'CP - The Impact of the Cold Plasma in the Magnetospheric Physics',
    hosts:
      'Gian Luca Delzanno, Natalia Buzulukosva, Barbara Giles, Roger Varney, and Joe Borovsky',
  },
  SCIMM: {
    longName: 'SCIMM - Self-Consistent Inner Magnetospheric Modeling',
    hosts: 'Cristian Ferradas, Chao Yue, Jacob Bortnik, and Qianli Ma',
  },
  GIC: {
    longName:
      'GIC - Understanding the causes of geomagnetic disturbances in geospace for hazard analysis on geomagnetically induced currents',
    hosts:
      'Xueling Shi, Dogacan Su Ozturk, Mark Engebretson, Zhonghua Xu, E. Joshua Rigler',
  },
  MESO: {
    longName:
      'MESO - Mesoscale drivers of the nightside transition region: Ionospheric and magnetotail evaluations',
    hosts:
      'Bea Gallardo-Lacourt, Gareth Perry, Emma Spanswick, Yari Collado-Vega, and Bashi Ferdousi',
  },
  MPEC: {
    longName:
      'MPEC - Magnetospheric sources of particle precipitation and their role on electrodynamic coupling of magnetosphere-ionosphere-thermosphere systems',
    hosts:
      'Dogacan Su Ozturk, Dong Lin, Yiqun Yu, Katherine Garcia-Sage, Stephen Kaeppler',
  },
  COMP: {
    longName: 'COMP - Comparative Planetary Magnetospheric Processes',
    hosts:
      'George Clark, Wen Li, Bob Marshall, Dan Gershman, Peter Delamere, Shannon Curry',
  },
  KiTS: {
    longName:
      'KiTS - Kinetic Plasma Processes in the MagnetoTail during Substorm Dynamics',
    hosts: 'Harry Arnold, Jason Derr, Akhtar Ardakani, Anton Artemyev',
  },
  MLGEM: {
    longName:
      'MLGEM - Machine Learning as it pertains in the Geospace Environment',
    hosts:
      'Hyunju Connor, Matthew Argall, Xiangning Chu, Banafsheh Ferdousi,Sai Gowtam Valluri',
  },
  MMV: {
    longName: 'MMV - Modeling Methods and Validation',
    hosts: 'Mike Liemohn, Lutz Rastaetter, Alexa Halford, Josh Rigler',
  },
  GMAG: {
    longName: 'GMAG - Ground Based Matnetometer Array',
    hosts: 'Zhonghua Xu, Michelle Salzano, Jenn Gannon',
  },
  MDT: {
    longName:
      "MDT - Multiscale Dayside Transients and their Effect on Earth's Magnetosphere",
    hosts: 'Savvas Raptis, Ivan Vansko, Imogen Gingell, Terry Z. Liu, Ying Zou',
    blocks: ['tuesday-1'],
  },
  SBCCI: {
    longName: 'SBCCI - The Sam Bingham Community Cares Initiative',
    subcommittee: ['GEM Steering Committee'],
  },
  CEDAR: {
    longName:
      'CEDAR - Coupling, Energetics and Dynamics of Atmospheric Regions Program',
  },
}
